module.exports = __webpack_public_path__ + "img/duoLogo.e72b79f2.png";